import secondaryComponents from "../../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import globalStyles from "../../../../../../assets/styles/base/globalPage.module.scss";
import { BackButton } from "../../../../../../components/primaryComponents";
import { GoodsReceivedForm } from "../../../../../../components/secondaryComponents/GoodsReceived";

export const CreateGoodsReceived = () => {
  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Create Goods Received Note"
      description="Create new goods received note"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <div className="d-flex align-items-center">
            <BackButton />
            <h4 className="ml-2 mb-0">Create GRN</h4>
          </div>

          <GoodsReceivedForm />
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
